import React from 'react';
import Immutable, { List } from 'immutable';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  Container,
  Image,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Paragraph,
  CoreLink,
} from '@uncinc/react-drupal-core';


import PrevNext from '../../../../components/PrevNext';
import SelectedContent from '../../../../components/SelectedContent';
import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
  OVERVIEW_REDIRECT,
} from '../../../../config/constants';

import './style.scss';

const NodeProjectDetail = ({ entity, className }) => {
  const { t } = useTranslation();
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));

  const title = entity.getIn(['title', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'processed']);
  const image = entity.getIn(['field_image', 0, 'styles'], null);
  const date = entity.getIn(['created', 0, 'value']);
  const relatedArticles = entity.getIn(['field_related_articles'], List());
  const storiesOverviewUrl = OVERVIEW_REDIRECT['stories'][currentLanguage];
  const taxonomyTermOverviewUrl = entity.getIn(['field_themes', 0, 'url']);

  return (
    <article className="NodeProjectDetail">

      {/* Start of Hero */}
      <Container>
        <div className="NodeProjectDetail__heroimage">
          <div className="row">
            <div className="col-12 col-md-10">
              {image && (
                <Image
                  alt={title}
                  lazyload
                  includeWebP
                  src={{
                    [SCREEN_MOBILE]: image.get('crop_3_1'),
                    [SCREEN_TABLET]: image.get('crop_3_1'),
                    [SCREEN_NORMAL]: image.get('crop_3_1'),
                  }}
                />
              )}
            </div>
            <div className="NodeProjectDetail__title col-12 order-md-first col-md-2">
              <div className="NodeProjectDetail__title-box">
                <CoreLink className="link" to={taxonomyTermOverviewUrl}>
                  <i className="icon icon-arrow-left icon-variant-0" />{t('project.back_to_overview')}
                </CoreLink>
                <h1 className="asH2">{title}</h1>
              </div>
            </div>
          </div>
        </div>

        {/* End of Hero */}
      </Container>

      {/* Start of Body */}
      <Container>
        <div className="NodeProjectDetail__body">
          <div className="row">
            <div className="col-12 col-md-8 offset-md-2">
              <WysiwygField
                property="schema:text"
                html={body}
              />
            </div>
          </div>
        </div>
      </Container>
      {/* End of Body */}

      {/* Start of paragraphs */}
      {
        entity.get('field_paragraphs', Immutable.List()).size > 0 ? (
          <div className="node--page--paragraphs-wrapper">
            {entity.get('field_paragraphs', Immutable.List()).map((paragraph) => {
              const id = paragraph.get('target_id');
              return (
                <Paragraph
                  key={`paragraph:${id}`}
                  id={id}
                  entity={paragraph.get('entity')}
                />
              );
            })}
          </div>
        ) : null
      }
      {/* End of paragraphs */}

      {/* Start of Relevant stories section */}
      {relatedArticles.size > 0 && (
        <SelectedContent
          title={t('stories.stories')}
          text={t('stories.selected_intro')}
          linkTitle={t('stories.read_more')}
          linkUrl={storiesOverviewUrl}
          entities={relatedArticles}
        />
      )}
      {/* End of Relevant stories section */}

      {/* Start of PrevNext section */}
      <div className="NodeProjectDetail__prevnext">
        <PrevNext date={date} type="project" />
      </div>
      {/* End of PrevNext section */}

    </article>
  );
};

export default NodeProjectDetail;
